// extracted by mini-css-extract-plugin
export default {"titleContainer":"Interaction_titleContainer_mMWVZ"};